import React from 'react';
import { serverHelpers } from '@pik/pik-utils';
import styled from 'styled-components';
import { media } from '@pik/pik-ui';

import Video from '../components/Videos/components/Video';

import api from '../common/api';
import langList from '../common/constants/langList';

import { wrapper } from '../services/store';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 32px;
  
  @media ${media.max1120} {
    grid-template-columns: 1fr 1fr;
  }
  
  @media ${media.max768} {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const Page = ({ pageData }) => (
  <Wrapper>
    {pageData.videos.map((item) => (
      <Video
        video={item}
        isEng={pageData.lang === langList.ENG}
        isVideoPage
      />
    ))}
  </Wrapper>
);

export const getServerSideProps = wrapper.getServerSideProps(async (ctx) => {
  try {
    const { appService: { lang } } = ctx.store.getState();
    const pageData = await api.appApi.fetch('GET', '/about/api/v1/page/videos');

    return {
      props: {
        pageData: {
          ...pageData,
          lang,
        },
      },
    };
  } catch (error) {
    const errorObject = serverHelpers.errorFormatter(error, ctx);
    console.error(errorObject);
    ctx.res.statusCode = errorObject.statusCode;

    return {
      props: {
        error: errorObject,
      },
    };
  }
});

export default Page;
